

import { createAction } from '@reduxjs/toolkit';

//export const SET_DATE_RANGE = 'SET_DATE_RANGE';

export const setDateRange = createAction('SET_DATE_RANGE', (startDate, endDate) => ({
  payload: { startDate, endDate },
}));

export const setSelectedRadioOption = createAction('SET_SELECTED_RADIO_OPTION', (selectedOption) => ({
	payload: { selectedOption },
  }));
  